import { render, staticRenderFns } from "./PosSupplier.vue?vue&type=template&id=cc80d762&scoped=true&"
import script from "./PosSupplier.vue?vue&type=script&lang=js&"
export * from "./PosSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc80d762",
  null
  
)

export default component.exports